module.exports = __webpack_public_path__ + "img/Aura_healing.69487ec3.png";